import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const AttendanceRedux = createActions({
  AttendanceByHourExcelRequest: [''],
  AttendanceByHourExcelSuccess: [''],
  AttendanceByHourExcelError: ['error'],
  AttendanceExcelRequest: [''],
  AttendanceExcelSuccess: [''],
  AttendanceExcelError: ['error'],
},
{
  prefix: 'ATTENDANCE_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = AttendanceRedux
export const AttendanceTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const AttendanceByHourExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const AttendanceByHourExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const AttendanceByHourExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

const AttendanceExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const AttendanceExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const AttendanceExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.AttendanceByHourExcelRequest]: AttendanceByHourExcelRequest,
  [Types.AttendanceByHourExcelSuccess]: AttendanceByHourExcelSuccess,
  [Types.AttendanceByHourExcelError]: AttendanceByHourExcelError,
  [Types.AttendanceExcelRequest]: AttendanceExcelRequest,
  [Types.AttendanceExcelSuccess]: AttendanceExcelSuccess,
  [Types.AttendanceExcelError]: AttendanceExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/AttendanceRedux.js